import apiFetch from '../../apiFetch'

export default function (token, purchaseId, registrationDeliveryId, parentIsHistorical, lastAccessDate) {
  return apiFetch({ endPoint: `dossier/purchase/${purchaseId}/reassignToRegistrationDelivery/${registrationDeliveryId}?parentIsHistorical=${parentIsHistorical}`, method: 'PUT', body: null, token: token, lastAccessDate })
}
